<template>
    <div class="category-view relative bg-theme-gray w-full flex h-auto">

        <div class="w-full pb-40 h-auto pt-0 laptop:pt-0">
            <section class="ml-20 my-6">
                <p class="text-sm text-txt-lightgray ml-4"><router-link class="hover:underline" to="/">HOME</router-link>
                </p>
            </section>

            <section class="flex flex-wrap ml-20">
                <article v-for="item in view_data.items" :key="item.id" class="bg-theme-white w-96 h-60 ml-4 mb-4">
                    <!--<article v-for="(product, key, index) in state.item" :key="index" class="flex bg-theme-white w-96 h-60 ml-4 mb-4">-->
                    <!--<p>{{ key }} is {{ product }}</p>-->
                    <router-link class="flex h-full hover:opacity-70 transition uration-300"
                        :to="{ name: 'Group', query: { operationtype: 'group', webcat_view: item.webcat_view, cassette_id: item.cassette_id } }">
                        <div class="w-2/5 flex justify-center items-center">
                            <img class="w-11/12" :src="img_path + item.cassette_img01">
                        </div>
                        <div class="w-3/5 flex flex-col justify-evenly p-3">
                            <div class="name">
                                <h1 class="text-lg font-bold">{{ item.cassette_block_name }}</h1>
                                <p class="text-xs"><span>メーカー：</span>{{ item.maker_name }}</p>
                            </div>
                            <div class="price w-max">
                                <p class="text-xs text-txt-red">税抜</p>
                                <p class="text-2xl text-txt-red">{{ item.cassette_price_off }}<span>円</span></p>
                                <p class="text-xs text-right text-txt-red"><span>（税込</span> {{ item.cassette_price_on }}円）
                                </p>
                            </div>
                            <div class="comment-area">
                                <p class="text-xs">{{ item.cassette_comment01 }}</p>
                            </div>
                        </div>
                    </router-link>
                </article>
            </section>
            <section class="ml-20 my-6">
                <p class="text-sm text-txt-lightgray ml-4"><router-link class="hover:underline" to="/">HOME</router-link>
                </p>
            </section>
        </div>
    </div>
    <Footer></Footer>
</template>



<script>

// import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive } from 'vue';
import Footer from '@/components/Footer.vue';
import axios from 'axios'
import { search_json } from '@/json.config.js';

export default {
    components: {
        Footer
    },
    name: 'categoryview',

    setup() {
        const route = useRoute()
        const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/";
        const search_data = ref([])
        const view_data = reactive({
            items: null
        })

        watchEffect(() => {
            const search_word = ref(route.query.searchtxt)
            // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search.json"
            // console.log(search_word.value)
            //タイトル変更
            document.title = search_word.value + "の検索結果｜イチオシ";


            search_data.value = []
            async function search() {
                const all_data = await axios.get(search_json)

                // 検索ワード
                search_word.value = route.query.searchtxt
                // 検索ワードをスペースで区切り配列に格納
                let search_words = search_word.value.split(/\s+/)
                // let count = search_words.length
                let count = search_words.length
                // console.log(count)

                // 検索ワードの数毎に処理を分岐 検索ワードを含むデータを配列に格納
                if (count === 1) {
                    all_data.data.forEach(function (value) {
                        if (value.allitems.indexOf(search_words[0]) !== -1) {
                            search_data.value.push(value)
                        }
                    })
                } else if (count === 2) {
                    all_data.data.forEach(function (value) {
                        if (value.allitems.indexOf(search_words[0]) !== -1 && value.allitems.indexOf(search_words[1]) !== -1) {
                            search_data.value.push(value)
                        }
                    })
                } else if (count === 3) {
                    all_data.data.forEach(function (value) {
                        if (value.allitems.indexOf(search_words[0]) !== -1 && value.allitems.indexOf(search_words[1]) !== -1 && value.allitems.indexOf(search_words[2]) !== -1) {
                            search_data.value.push(value)
                        }
                    })
                }

                view_data.items = []
                for (let i = search_data.value.length - 1; i >= 0; i--) {
                    let val = search_data.value[i]
                    const group_id = val.cassette_id.split("_")[0];
                    // console.log(group_id)

                    let price_on = String(val.cassette_price_on)
                    // console.log(price_on)
                    let check_letter_on = price_on.indexOf("～")
                    if (check_letter_on == -1) {
                        price_on = price_on.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        // console.log(price_on)
                    } else {
                        price_on = price_on.substring(0, price_on.length - 1)
                        price_on = price_on.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        price_on = price_on + "～"
                        // console.log(price_on)
                    }
                    // console.log(price_on)
                    // 税抜価格の表示のやつ
                    let price_off = String(val.cassette_price_off)
                    let check_letter_off = price_on.indexOf("～")
                    if (check_letter_off == -1) {
                        price_off = price_off.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        // console.log(price_on)
                    } else {
                        price_off = price_off.substring(0, price_off.length - 1)
                        price_off = price_off.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        price_off = price_off + "～"
                        // console.log(price_off)
                    }

                    const item_val = {
                        [group_id]: {
                            cassette_id: val.cassette_id.split("_")[0],
                            webcat_view: val.webcat_view,
                            cassette_block_name: val.cassette_block_name,
                            maker_name: val.maker_name,
                            cassette_img01: val.cassette_img01,
                            sold_out_block: val.sold_out_block,
                            cassette_comment01: val.cassette_comment01,
                            // cassette_price_on:parseInt(val.cassette_price_on, 10),
                            // cassette_price_off:parseInt(val.cassette_price_off,10)
                            cassette_price_on: price_on,
                            cassette_price_off: price_off
                        }
                    }

                    // console.log(item_val)
                    view_data.items = Object.assign(view_data.items, item_val)
                }
                view_data.items = Object.values(view_data.items)
            }
            search()
            // console.log(view_data)
        })
        return {
            // search_word,
            watchEffect,
            img_path,
            view_data
        }
    }
}



</script>

